
function pageInit () {

}

var __blk_myrecords = new Vue({
  mixins: [mPanination],
  data () {
    return {
      loading: true,
      total: 0,
      courseList: {},
      // resultList: [],
      condition: {
        sort: '',
        per_page: 15,
        page: 1,
        keyword: ''
      },
      curr_audio: ''
    }
  },
  methods: {
    playAudio (id) {
      if (this.curr_audio) {
        if (this.curr_audio === id) {return}
        if (document.getElementById('audio_' + this.curr_audio)) {
          try {
            document.getElementById('audio_' + this.curr_audio).pause()
            document.getElementById('audio_' + this.curr_audio).currentTime = 0
          } catch (e) {}
        }
        if (this.curr_audio.indexOf('_user') !== -1) {
          $('#icon_' + this.curr_audio).css({'background-image': 'url("resource/player/i/uplay.svg")'})
        } else {
          $('#icon_' + this.curr_audio).css({'background-image': 'url("resource/player/i/play.svg")'})
        }
      }
      try {
        document.getElementById('audio_' + id).play()
      } catch (e) {}
      if (id.indexOf('_user') !== -1) {
        $('#icon_' + id).css({'background-image': 'url("resource/player/i/uplaying.svg")'})
      } else {
        $('#icon_' + id).css({'background-image': 'url("resource/player/i/playing.svg")'})
      }

      this.curr_audio = id
    },
    onendedAudio (obj, type) {
      let id = $(obj).attr('id')
      if (!id) {return}
      id = id.replace('audio_', 'icon_')
      if (type === 'user') {
        $('#' + id).css({'background-image': 'url("resource/player/i/uplay.svg")'})
      } else {
        $('#' + id).css({'background-image': 'url("resource/player/i/play.svg")'})
      }
      this.curr_audio = ''
    },
    search () {
      let self = this
      let qs = {}
      for (let i in this.condition) {
        if (typeof this.condition[i] === 'string') {
          qs[i] = encodeURIComponent($.trim(this.condition[i]))
        } else {
          qs[i] = this.condition[i]
        }
      }
      self.loading = true

      let cl = new km_cl('search')
      cl.cmdA.push({func: function () {
        post({
          type: 'post',
          url: '/api/records/me',
          data: qs
        }, function (resp) {
          if (resp.status === 'success') {
            self.loading = false
            self.total = resp.total
            if (resp.data.length > 0) {
              for (let i of resp.data) {
                if (!i['course'] || !i.course['id']) {continue}
                if (!self.courseList['course_' + i.course.id]) {
                  self.courseList['course_' + i.course.id] = {
                    id: i.course.id,
                    name: i.course.name,
                    resultList: []
                  }
                }
                let course_id = i.course.id
                delete i['course']
                self.courseList['course_' + course_id].resultList.push(JSON.parse(JSON.stringify(i)))
              }
            }

            self.$nextTick(function () {
              $('.container').scrollTop(0)
            })
          } else {
            self.$message(resp.message)
          }
        }, function (resp) {})
      }})
      cl.cmdI = 0
      cl.doCmdA()
    }
  },
  mounted () {
    this.search()
  }
})

